/* eslint-disable */
import link from './index.json';
import { loadScript, stopClickThrough } from '~/utils/common';
import { getStaticUrl } from '~/utils/env.js';
import { initTrack, trackpv } from '~/utils/track';
const url = '//api.map.baidu.com/api?v=2.0&ak=tgELalGNumraHZdVurYllitGmvd7RC6R&s=1&&callback=mapinit';
const config = {
    subway: {
        imgUrlAct: process.env.IS_AJK ? getStaticUrl(link.ajkmetro) : getStaticUrl(link['58metro']),
        imgUrlDefault: getStaticUrl(link.metro),
        icon: process.env.IS_AJK ? link.mark_metro : link.mark_metro2,
        keyWords: '地铁',
        isActive: false,
        hasFinish: false
    },
    bus: {
        imgUrlAct: process.env.IS_AJK ? getStaticUrl(link.ajktransit) : getStaticUrl(link['58transit']),
        imgUrlDefault: getStaticUrl(link.transit),
        icon: process.env.IS_AJK ? link.mark_transit : link.mark_transit2,
        keyWords: '公交',
        isActive: false,
        hasFinish: false
    },
    school: {
        imgUrlAct: process.env.IS_AJK ? getStaticUrl(link.ajkschool) : getStaticUrl(link['58school']),
        imgUrlDefault: getStaticUrl(link.school),
        icon: process.env.IS_AJK ? link.mark_school : link.mark_school2,
        keyWords: '学校',
        isActive: false,
        hasFinish: false,
        sub: {
            all: {
                keyWords: '全部学校',
                icon: process.env.IS_AJK ? link.mark_school : link.mark_school2,
                isActive: true,
                index: 0,
                hasFinish: false
            },
            kindergarten: {
                keyWords: '幼儿园',
                icon: process.env.IS_AJK ? link.mark_school : link.mark_school2,
                isActive: false,
                index: 1,
                hasFinish: false
            },
            primary: {
                keyWords: '小学',
                icon: process.env.IS_AJK ? link.mark_school : link.mark_school2,
                isActive: false,
                index: 2,
                hasFinish: false
            },
            middle: {
                keyWords: '中学',
                icon: process.env.IS_AJK ? link.mark_school : link.mark_school2,
                isActive: false,
                index: 3,
                hasFinish: false
            },
            high: {
                keyWords: '高等学校',
                icon: process.env.IS_AJK ? link.mark_school : link.mark_school2,
                isActive: false,
                index: 4,
                hasFinish: false
            }
        }
    },
    hospital: {
        imgUrlAct: process.env.IS_AJK ? getStaticUrl(link.ajkhospital) : getStaticUrl(link['58hospital']),
        imgUrlDefault: getStaticUrl(link.hospital),
        icon: process.env.IS_AJK ? link.mark_hospital : link.mark_hospital2,
        keyWords: '医院',
        isActive: false,
        hasFinish: false
    },
    restaurant: {
        imgUrlAct: process.env.IS_AJK ? getStaticUrl(link.ajkrestaurant) : getStaticUrl(link['58restaurant']),
        imgUrlDefault: getStaticUrl(link.restaurant),
        icon: process.env.IS_AJK ? link.mark_restaurant : link.mark_restaurant2,
        keyWords: '餐饮',
        isActive: false,
        hasFinish: false
    },
    shopping: {
        imgUrlAct: process.env.IS_AJK ? getStaticUrl(link.ajkgwc) : getStaticUrl(link['58gwc']),
        imgUrlDefault: getStaticUrl(link.gwc),
        icon: process.env.IS_AJK ? link.mark_gwc : link.mark_gwc2,
        keyWords: '购物',
        isActive: false,
        hasFinish: false
    },
    bank: {
        imgUrlAct: process.env.IS_AJK ? getStaticUrl(link.ajkbank) : getStaticUrl(link['58bank']),
        imgUrlDefault: getStaticUrl(link.bank),
        icon: process.env.IS_AJK ? link.mark_bank : link.mark_bank2,
        keyWords: '银行',
        isActive: false,
        hasFinish: false
    }
};
export default {
    async asyncData(context) {
        const { query, route, req } = context;
        const host = req.headers.host;
        const href = host + route.path;
        let Config = config;
        if (query.metro != '1') {
            delete Config.subway;
        }
        let index = 0;
        for (let key in Config) {
            Config[key].index = index;
            index++;
        }
        await console.log('queryqueryquery', query);
        return {
            href,
            query,
            Config,
            schoolList: Config.school.sub
        };
    },
    inject: ['CITY'],
    head() {
        return {
            title: this.title,
            meta: [
                { name: 'apple-mobile-web-app-capable', content: 'yes' },
                { name: 'apple-touch-fullscreen', content: 'yes' },
                { name: 'applicable-device', content: 'mobile' },
                { name: 'keywords', content: this.keyWords },
                { name: 'description', content: this.description }
            ],
            link: [
                {
                    href: this.href,
                    rel: 'canonical'
                }
            ]
        };
    },
    data() {
        return {
            map: null,
            result: {},
            local: null,
            point: null,
            list: [],
            showList: false,
            actKey: '',
            subActKey: '',
            isCenter: false
        };
    },
    computed: {
        title() {
            return process.env.IS_AJK
                ? `${this.CITY.name}地图，${this.query.adr}周边配套设施，${this.CITY.name}安居客`
                : `【${this.CITY.name}地图，${this.query.adr}周边配套设施】，${this.CITY.name}58同城`;
        },
        keyWords() {
            return `${this.query.adr}地图,${this.query.adr}周边配套设施`;
        },
        description() {
            return process.env.IS_AJK
                ? `安居客小区频道，提供${this.query.adr}二手房，${this.query.adr}租房，${this.query.adr}房价走势、实景图、房型图、周边交通配套信息就上安居客`
                : `58同城小区频道，提供${this.query.adr}二手房，${this.query.adr}租房，${this.query.adr}房价走势、实景图、房型图、周边交通配套信息就上58同城`;
        }
    },
    mounted() {
        initTrack(
            {
                pageName: 'M_COMM_Page_NewMap',
                plat: 2
            },
            { url: '' }
        );
        trackpv();
        this.initMap();
    },
    methods: {
        initMap() {
            window.mapinit = () => {
                this.map = new BMap.Map('map');
                this.point = new BMap.Point(this.query.lng, this.query.lat);
                this.map.centerAndZoom(this.point, 18);
                this.map.enableContinuousZoom(); // 启用连续缩放效果
                this.map.enableInertialDragging(); // 启用地图惯性拖拽
                this.map.setMinZoom(9); // 设置地图允许的最小级别
                this.creatCenterPoint();
                if (this.query.type) {
                    this.clickTab(this.query.type);
                }
            };
            window.onload = loadScript(url, 'body');
        },
        searchSchool(tab, key) {
            this.map && this.map.clearOverlays();
            this.creatCenterPoint();
            this.list = [];
            this.navScroll(this.schoolList[key].index, 'schoolList');
            this.subActKey = this.schoolList[key];
            this.subActKey.key = key;
            for (const item in this.schoolList) {
                this.schoolList[item].isActive = false;
            }
            this.schoolList[key].isActive = true;
            this.schoolList[key].isActive && !this.result[key] && this.searchLocal(key, 'schoolList');
            this.result[key] && this.setSearchOverlay(this.result[key], key, 'schoolList');
        },
        clickTab(key, item) {
            this.map && this.map.clearOverlays();
            this.creatCenterPoint();
            this.list = [];
            this.navScroll(this.Config[key].index, 'Config');
            const zoom = this.map.getZoom();
            if (zoom !== 14) {
                this.map.centerAndZoom(this.point, 14);
            }
            this.Config[key].isActive = !this.Config[key].isActive;
            for (const i in this.Config) {
                i !== key && (this.Config[i].isActive = false);
            }
            this.Config[key].isActive && (this.actKey = key);
            this.Config[key].isActive && !this.result[key] && this.searchLocal(key, 'Config'); // 如果当前result中没有数据，那么进入搜索。
            // 如果有数据，直接解析数据并标注地图
            this.result[key] && this.Config[key].isActive && this.setSearchOverlay(this.result[key], key, 'Config');
            if (!this.Config[key].isActive) {
                this.showList = false;
                this.map.panBy(0, 0);
                stopClickThrough.beforeClose();
                this.isCenter = false;
            }
            if (!this.showList) {
                this.map.centerAndZoom(this.point, 14);
            }
        },
        navScroll(index, config) {
            // 当前index
            const halfWidth = document.getElementById('tab').clientWidth / 2;
            const className = config === 'Config' ? 'tab-item' : 'map-result-button-item';
            const tabId = config === 'Config' ? 'tab' : 'school';
            let itemWidth = document.getElementsByClassName(className)[index].offsetWidth / 2;
            for (let i = 0; i < index; i++) {
                itemWidth += document.getElementsByClassName(className)[i].offsetWidth;
            }
            if (itemWidth > halfWidth) {
                document.getElementById(tabId).scrollLeft = itemWidth - halfWidth;
            } else {
                document.getElementById(tabId).scrollLeft = 0;
            }
        },
        // 设置新标注
        creatNewMarker(iconImg, pt, width = 24, height = 30) {
            const myIcon = new BMap.Icon(getStaticUrl(iconImg), new BMap.Size(width, height));
            myIcon.imageSize = new BMap.Size(width, height);
            myIcon.anchor = new BMap.Size(width, height * 2);
            const marker = new BMap.Marker(pt, {
                icon: myIcon
            });
            return marker;
        },
        creatCenterPoint() {
            // 创建中心点图标
            const marker = this.creatNewMarker(link.point, this.point, 24, 24);
            this.map.addOverlay(marker);
        },
        // 搜索附近
        searchLocal(key, config) {
            this.local = new BMap.LocalSearch(this.map, {
                onSearchComplete: this.buildOptions(key, config).onSearchComplete
            });
            this.local.setPageCapacity(20);
            this.local.searchNearby(this[config][key].keyWords, this.point, 2000);
        },
        // 搜索完成时的回调
        buildOptions(key, config) {
            const _this = this;
            return {
                onSearchComplete(results) {
                    // 判断状态是否正确
                    if (_this.local.getStatus() == BMAP_STATUS_SUCCESS) {
                        if (
                            (key !== _this.actKey && config === 'Config') ||
                            (key !== (_this.subActKey && _this.subActKey.key) && config === 'schoolList')
                        )
                            return false;
                        _this.result[key] = results; // 将获取到的结果存到result中
                        _this.setSearchOverlay(_this.result[key], key, config); // 标注地图
                    } else if (_this.local.getStatus() == BMAP_STATUS_UNKNOWN_LOCATION) {
                        _this[config][key].hasFinish = true;
                        _this.showList = true;
                        if (!_this.isCenter) {
                            _this.map.panBy(0, -100);
                            _this.isCenter = true;
                        }

                        stopClickThrough.afterOpen();
                    }
                }
            };
        },
        setSearchOverlay(array, key, config) {
            this.list = [];
            const link = this[config][key].icon;
            for (let i = 0; i < array.getCurrentNumPois(); i++) {
                const nowPoint = new BMap.Point(array.getPoi(i).point.lng, array.getPoi(i).point.lat);
                const marker = this.creatNewMarker(link, nowPoint);
                const distence = this.map.getDistance(this.point, nowPoint);
                this.map.addOverlay(marker);
                this.list.push({
                    name: array.getPoi(i).title,
                    address: array.getPoi(i).address,
                    distance: distence
                });
            }
            this.list.sort((a, b) => {
                return a.distance - b.distance;
            });
            this.showList = true;
            // this.map.centerAndZoom(this.point, 14);
            if (!this.isCenter) {
                this.map.panBy(0, -100);
                this.isCenter = true;
            }
            stopClickThrough.afterOpen();
            this[config][key].hasFinish = true;
            // this.map.centerAndZoom(this.point, 14);
        },
        pullStart() {
            const mo = function(e) {
                e.preventDefault();
            };
            document.body.style.overflow = 'hidden';
            document.addEventListener('touchmove', mo, false); // 禁止
        },
        pullMove() {},
        pullOut() {
            const mo = function(e) {
                e.preventDefault();
            };
            document.body.style.overflow = ''; // 出现滚动条
            document.removeEventListener('touchmove', mo, false);
        }
    }
};
